module.exports = __webpack_public_path__ + "img/arrow_back.84ec7710.svg";